import axios from 'axios';



const url=process.env.REACT_APP_BASE_URL



export const PostLimitData=async(bankData,postData,setOpenAlert,setAlertType,setAlertMessage,setOpenLoader)=>{
    let mapping={
        Cash:'cash',
        CDM:'cdm',
        Cheque:'cheque',
        "Online Transfer":"online_transfer",
        "NEFT-RTGS":"neft_rtgs",
        "IMPS":"imps",
        "UPI":"upi"
    }
console.log(bankData);
console.log(postData);
    const formdata=new FormData();

    
    formdata.append('fia_bank_id',parseInt(postData.fia_bank_id))
    formdata.append('type_of_request',mapping[postData.topup_mode])
    formdata.append('amount',parseFloat(postData.amount))
    formdata.append('transaction_date',postData.transfer_date)
    formdata.append('remarks',postData.remarks?postData.remarks:null)

    if(postData.topup_mode!=='Cash'&&postData.topup_mode!=='CDM'&&postData.topup_mode!=='Cheque'&&postData.topup_mode!=='UPI'){
        formdata.append('transfer_reference',postData.txn_ref_no)
    }

    if(postData.topup_mode==='Cheque'){
        formdata.append('cheque_no',postData.cheque_number)
    }

    if(postData.topup_mode==="Cash"||postData.topup_mode==='CDM'){
        formdata.append('file',postData.bank_recipt)
    }

   

    // if(){
    //     formdata.append('transfer_reference',postData.txn_ref_no)
    // }

    if(postData.topup_mode!=="IMPS"){
        formdata.append('registered_account_id',parseInt(postData.userBank_id))

    }
    
    try {
        setOpenLoader(true)

        await axios.post(`${url}/topup_request`,formdata,{
            headers:{
                'Authorization':`Bearer ${sessionStorage.getItem('UserToken')}`,
                'Content-Type':'multipart/form-data'
            }
        })
        .then(res=>{
            setOpenLoader(false)
            if(res.status===201){
                setAlertType('success')
                setAlertMessage('Topup request sent successfully')
                setOpenAlert(true)
            }
 
        })
       
        
    } catch (error) {
        setOpenLoader(false)
        setAlertType('error')
        setAlertMessage(error.response&&error.response.data.message?error.response.data.message:'something went wrong!!!')
        setOpenAlert(true)
        console.log(error)
    }
}


export const getBankName=async(setData)=>{
    try {
        await axios.get(`${url}/fia_bank_info`,{
            headers:{
                'Authorization':`Bearer ${sessionStorage.getItem('UserToken')}`
            }
        })
        .then((res)=>{
            setData(res.data)
        })   
    } 
    catch (error) {
        console.log(error)
    }
}


export const getAccountDetails=async(setData,type,setOpenAlert, setAlertType, setAlertMessage)=>{
    try {
        await axios.post(`${url}/account_details`,{
            type_of_account:type
        },
        {
            headers:{
                'Authorization':`Bearer ${sessionStorage.getItem('UserToken')}`
            }
        })
       .then((res)=>{
            setData(res.data)
        })   
    } 
    catch (error) {
        setAlertType('error')
        setAlertMessage(error.response&&error.response.data.message?error.response.data.message.message:'something went wrong!!!')
        setOpenAlert(true)
        console.log(error.response.data.message)
    }
}